import { render, staticRenderFns } from "./LocalNote.vue?vue&type=template&id=aa06cd50&scoped=true&"
import script from "./LocalNote.vue?vue&type=script&lang=js&"
export * from "./LocalNote.vue?vue&type=script&lang=js&"
import style0 from "./LocalNote.vue?vue&type=style&index=0&id=aa06cd50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa06cd50",
  null
  
)

export default component.exports